import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  type CampaignBanner,
  type GetCampaignBannersParams,
  getCampaignBannersFn,
} from './ahafood/campaign-banner';

export const useGetCampaignBanners = (
  params: GetCampaignBannersParams,
  opts?: Omit<UseQueryOptions<CampaignBanner[], Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<CampaignBanner[], Error>({
    queryKey: ['campaignBanners', params],
    queryFn: () => getCampaignBannersFn(params),
    ...opts,
  });
};
